<script lang="ts">
    import { loadItems } from "../utils";
    import Gallery from "./Gallery.svelte";
    import Carousel from "svelte-carousel";

    let carousel; // for calling methods of the carousel instance
    const handleNextClick = () => {
        carousel.goToNext();
    };

    let carouselImages = [];

    // MENU 5b87df90-ae1c-11ea-827d-a91f136d806f
    const fetchImage: Promise<any> = (async () => {
        return loadItems("5b87df90-ae1c-11ea-827d-a91f136d806f").then(
            (resp) => {
                
                const string = decodeURI(JSON.parse(resp).data.viewGallery.content)

                const imgRex = /<img.*?src="(.*?)"[^>]+>/g;
                const images = [];
                let img;
                while ((img = imgRex.exec(string))) {
                    images.push(img[1]);
                    if(images.length > 10)
                        break
                }
                carouselImages = images
            }
        );
    })();
</script>

<svelte:head>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@100&display=swap"
        rel="stylesheet"
    />
</svelte:head>

<div class="home">
    <div class="home-carousel">
        {#if carouselImages.length > 0}
        <Carousel
            autoplay
            autoplayDuration={5000}
            autoplayProgressVisible
            pauseOnFocus
            bind:this={carousel}
        >
            {#each carouselImages as _, i}
                <img alt="error" src={carouselImages[i]} />
            {/each}
        </Carousel>
        {/if}
    </div>
</div>

<style>

    :global(body){
        background-color: lightseagreen;
        background-image: url("../backgrounds/Metsä.jpg");
        background-size: cover;
        background-repeat: no-repeat;
        background-attachment: fixed;
    }

    :global(.gallery span) {
        font-family: "Roboto", sans-serif !important;
        font-size: x-large;
        font-weight: bold;
        padding: 0px 0px;
    }

    :global(.home) {
        padding-top: 15px;
    }

    :global(.home img) {
        max-width: 100%;
    }

    @media (min-width: 640px) {
        :global(.gallery span) {
            font-family: "Roboto", sans-serif !important;
            font-size: xx-large;
            font-weight: bold;
            padding: 0px 0px;
        }

        :global(.home) {
            padding-top: 15px;
            max-width: 100%;
            display: flex;
            justify-content: center;
        }

        :global(.home-carousel) {
            max-width: 50%;
        }

        :global(.home img) {
            max-width: 65%;
        }
    }
</style>
